import { useMemo } from "react";

import { sanitizeCSSVarName } from "components/helpers";

export function useColumnSize({ table, columns = [] }) {
  const { columnSizingInfo, columnSizing } = table.getState();
  const columnSizeVars = useMemo(() => {
    if (!columns.length) return {};
    const headers = table.getFlatHeaders();
    const colSizes = {};
    for (let i = 0; i < headers.length; i++) {
      const header = headers[i];
      const sanitizedHeaderKey = sanitizeCSSVarName(
        `--header-${header.column.id}-size`
      );
      const sanitizedColKey = sanitizeCSSVarName(
        `--col-${header.column.id}-size`
      );
      colSizes[sanitizedHeaderKey] = header.getSize();
      colSizes[sanitizedColKey] = header.column.getSize();
    }
    return colSizes;
    // columnSizingInfo/columnSizing aren't read directly but signal when
    // header.getSize() values change and the memo must recompute.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnSizingInfo, columnSizing, table, columns]);

  return columnSizeVars;
}
